
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, FormControl, FormGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import BasicPage from '../../components/BasicPage';
import knownAttributes from './knownAttributes';

const Background = require('../../assets/login-background.jpg');

interface LoginState {
  newPasswordChallenge: boolean;
  requiredAttributes: string[];
  attributes: { [key: string]: any };
  newPassword: string;
}

@inject('authStore', 'routing')
@observer
export default class Login extends React.Component<any, LoginState> {
  callbacks: {
    callback: (newPassword: string, requiredAttribs: { [key: string]: any}) => any,
    error: (err: any) => any,
  };
  res: () => any;
  rej: (err: any) => any;

  constructor(props: any) {
    super(props);
    this.state = {
      newPasswordChallenge: false,
      requiredAttributes: [],
      attributes: {},
      newPassword: ''
    };
  }

  componentWillUnmount() {
    this.props.authStore.reset();
  }

  handleUserNameChange = (e: any) => this.props.authStore.setUserName(e.target.value);
  handlePasswordChange = (e: any) => this.props.authStore.setPassword(e.target.value);
  handleSubmitForm = (e: any) => {
    e.preventDefault();
    this.props.authStore.login({
      newPasswordRequired: (
        callbacks: any,
        userAttributes: any,
        requiredAttributes: any
      ) => {
        this.callbacks = callbacks;
        this.setState({
          newPasswordChallenge: true,
          requiredAttributes: requiredAttributes
        });
      }
    }).then(() => this.props.routing.history.replace('/dashboard'));
  }

  handleNewPasswordChange = (e: any) => this.setState({
    newPassword: e.target.value
  })
  handleAttributeChange(name: string, e: any) {
    this.setState({
      attributes: {
        ...this.state.attributes,
        [name]: e.target.value
      }
    });
  }
  handleAttributeForm = (e: any) => {
    e.preventDefault();
    this.callbacks.callback(
      this.state.newPassword,
      this.state.attributes
    );
  }

  renderCurrentForm = () => {
    let me  = this;
    const { values, inProgress, inNewPassProgress } = me.props.authStore;
    if (me.state.newPasswordChallenge) {
      let sortedAttribs = knownAttributes.filter(o => this.state.requiredAttributes.some(p => p === o.alias));
      return (
        <form onSubmit={me.handleAttributeForm}>
          <FormGroup>
            <FormControl
              type="password"
              placeholder="New Password"
              value={me.state.newPassword}
              onChange={me.handleNewPasswordChange.bind(this)}
            />
          </FormGroup>

          {sortedAttribs.map((attrib, index) => {
            return (
              <FormGroup key={index}>
                <FormControl
                  placeholder={attrib.name}
                  onChange={me.handleAttributeChange.bind(this, attrib.alias)}
                  {...attrib.props}
                />
              </FormGroup>
            );
          })}

          <Button
            bsSize="large"
            bsStyle="primary"
            type="submit"
            disabled={inNewPassProgress}
          >
            Save and Continue
          </Button>
        </form>
      );
    } else {
      return (
        <form onSubmit={me.handleSubmitForm}>
          <FormGroup>
            <FormControl
              type="text"
              placeholder="Username"
              value={values.userName}
              onChange={me.handleUserNameChange}
            />
          </FormGroup>

          <FormGroup>
            <FormControl
              type="password"
              placeholder="Password"
              onChange={me.handlePasswordChange}
            />
          </FormGroup>

          <Button
            bsSize="large"
            bsStyle="primary"
            type="submit"
            disabled={inProgress}
          >
            Login
          </Button>
        </form>
      );
    }
  }

  render() {
    return (
      <BasicPage title="Login" containerProps={{style: {background: `url("${Background}")`}}}>
        <p>
          <Link to="register">Need an account?</Link>
        </p>
          {this.renderCurrentForm.apply(this)}
      </BasicPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/container/Account/Login.tsx